import styled, { css } from 'styled-components'
import { theme, prop, palette, ifProp } from 'styled-tools'

const withArrow = css`
  display: inline-block;
  padding-right: ${theme('sizes.hAtom')};

  &:after {
    content: url('/icons/arrow_right_yoco_blue.svg');
    width: 18px;
    height: 11px;
    object-fit: contain;
    position: relative;
    top: 2px;
    margin-left: 5px;
  }
`

const WrapperLink = styled.a`
  color: ${prop('linkColor', palette('action'))};
  text-decoration: ${prop('textDecoration', 'none')};

  &:hover {
    color: ${prop('hoverColor', palette('border'))};
  }

  ${ifProp('hasArrow', withArrow)}
`

export default WrapperLink



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/components/atoms/Link/styled.js